import React from 'react';
import { InputMask } from '@react-input/mask';

export const PhoneInput = ({ id, value, onChange, required = false, disabled = false }) => {
    const mask = '(___) ___-____';

    const handleOnMask = (event) => {
        const val = event.detail.value === mask ? '' : event.detail.value;
        if (val !== value) {
            onChange && onChange(val);
        }
    };

    return (
        <InputMask
            id={id}
            mask={mask}
            replacement={{ _: /\d/ }}
            value={value ?? ''}
            required={required}
            onMask={handleOnMask}
            showMask={true}
            type='text'
            alwaysShowMask={false}
            disabled={disabled}
        />
    );
};
